export default {
  paged: {
    select: 'id,destinationUserId,processId,environmentId',
    searchSelect: ['destinationUser/fullName', 'process/name', 'environment/name'],
    notSelectSearch: 'destinationUser,process,environment',
    expand: {
      destinationUser: { select: 'fullName' },
      process: { select: 'name' },
      environment: { select: 'name' },
    },
  },
};
